export const SERVER = process.env.REACT_APP_SERVER;
export const API_URL = `${SERVER}/v1/`;
export const ASSET_URL = `${SERVER}/assets/`;
export const WINE_MODEL_XLS = `${SERVER}/models/wine.xlsx`;